import { readonly } from 'vue'
import { entityBranding } from '@akerolabs/akero-vue/src/services/entityBranding.js'

const operations = readonly([
  {
    type: 'create-lead',
    label: () => `Import ${entityBranding('leads.plural', 'Leads')}`,
    configurator: 'ak-integration-s-f-t-p-create-lead',
    getConfiguration: () => ({
      campaign: '',
      suppressed: null,
      fileType: '',
      rootPath: '', // for json
      referenceType: '', // for csv: column (position), header
      delimiter: ',', // for csv
      mappings: [],
    }),
    validator: (/*operation*/) => ({ valid: true }), // defer to backend validation
  },
])

export default operations

/**
 * Return an operation for a given type
 * @param {String} type
 * @returns {*}
 */
export const getOperationForType = (type) =>
  operations.find((e) => e.type === type)

/**
 * Return an operation validator for a given type
 * @param {String} type
 * @return {function}
 */
export const getOperationValidatorForType = (type) => {
  return getOperationForType(type).validator
}

/**
 * Return a record template for an operation of a given type
 * @param {String} type
 * @returns {*}
 */
export const getOperationRecordTemplate = (type) => ({
  name: '',
  type,
  configuration: getOperationForType(type).getConfiguration(),
  fileFilter: '',
  fileFilterConfiguration: {},
})
